import { __decorate } from "tslib";
import _ from 'lodash';
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DeleteButton from "../../DeleteButton.vue";
import MoveButton from "../../MoveButton.vue";
let InspectionListChoiceValueAutoComplete = class InspectionListChoiceValueAutoComplete extends Vue {
    inspectionListChoiceType;
    selectedId;
    selectedItem = null;
    isLoading = 0;
    onChoiceTypeChanged(newVal) {
        if (this.selectedId) {
            let selectedItem = this.inspectionListChoiceType?.choiceValues.find(item => item.id == this.selectedId);
            this.selectedItem = selectedItem;
        }
    }
    get sortedValues() {
        if (this.inspectionListChoiceType)
            return _.orderBy(this.inspectionListChoiceType.choiceValues, ['sortOrder', 'id']);
        else
            return [];
    }
    get getTitle() {
        if (this.inspectionListChoiceType) {
            return this.inspectionListChoiceType.description;
        }
        return this.$t('choice-values').toString();
    }
};
__decorate([
    Prop({ required: true, default: null })
], InspectionListChoiceValueAutoComplete.prototype, "inspectionListChoiceType", void 0);
__decorate([
    Prop({ type: Number, required: true, default: null })
], InspectionListChoiceValueAutoComplete.prototype, "selectedId", void 0);
__decorate([
    Watch('inspectionListChoiceType')
], InspectionListChoiceValueAutoComplete.prototype, "onChoiceTypeChanged", null);
InspectionListChoiceValueAutoComplete = __decorate([
    Component({
        components: { MoveButton, DeleteButton }
    })
], InspectionListChoiceValueAutoComplete);
export default InspectionListChoiceValueAutoComplete;
